import { render } from "./CartTableRow.vue?vue&type=template&id=2f5c96bd&scoped=true"
import script from "./CartTableRow.vue?vue&type=script&lang=js"
export * from "./CartTableRow.vue?vue&type=script&lang=js"

import "./CartTableRow.vue?vue&type=style&index=0&id=2f5c96bd&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5c96bd"]])

export default __exports__